export const lang = {
    genesis:"THE GENESIS BLOCK IS COMPLETE",
    images: {
        tri: "tri-en-US.png",
        tps: "what-tps-en-US.png"
    },
    banner: {
        helixTitle: "HELIX 1.0",
        days: "Days",
        hours: "Hours",
        minutes: "Minutes",
        seconds: "Seconds",
        blockConfirmationTime: "Block Time of 0.5 Seconds",
        lowTransferFee: "Low Transfer Fee of 0.01 DNA",
        highTps: "10,000+ Transactions Per Second",
        moreInfoBtn: "More Information",
        goToExplorer: "Go to Explorer",
        b2t1: "DNA",
        b2c1: " chain operates on the DPoS consensus algorithm",
        b2t2: "DNA",
        b2c2: " will remain decentralized while allowing for near-instant transactions and incorporating all of the features needed for a future-proofed digital finance ecosystem.",
        network: "Network",
        architecture: "Architecture",
        findOutMore: "Find Out More"
    },
    navs: {
        explores: 'Explorers',
        wallets: 'Wallets',
        bounty: 'Bounty Program',
        build: 'Build on DNA',
        what: 'What is DNA?',
        mainnet: 'Helix 1.0',
        invest: 'Invest in DNA',
        development: 'Development Resources',
        download: 'Download',
        community: 'Community',
        connect: 'Connect with Us',
        global: 'Ambassadors Program',
        institute: 'DNA Blockchain Institute',
        aboutInstitute: 'About the Institute',
        open: 'Open Technology Standards',
        funding: 'Funding and Grants',
        testnet: 'Testnet',
        testnet_explorer: 'Explorer',
        testnet_dex: 'DEX',
        testnet_faucet: 'Faucet',
    },
    about: [
        {
            title: 'About DNA',
            text: 'Get to know Metaverse DNA to start experiencing the simplicity and speed of the network.',
            url: 'what',
            btn: 'Learn More'
        },
        {
            title: 'Resources',
            text: 'Learn about the technology behind Metaverse DNA so you can start building with its resources.',
            url: 'development',
            btn: 'Get Started'
        },
        {
            title: 'Community',
            text: 'See how you can join the DNA ecosystem and earn rewards with your accomplishments.',
            url: 'connect',
            btn: 'Join Us'
        }
    ],
    comingsoon: "Coming Soon.",
    learn: 'Learn More',
    rapid: {
        title: 'RAPID: The 5 Key Components of Next Generation Blockchain',
        btn: 'Learn More About Metaverse DNA'
    },
    metaverse: 'Metaverse DNA Whitepaper',
    metaText: 'A technical overview of Metaverse DNA and the original design for the modern decentralized finance infrastructure.',
    metaBtn: 'Metaverse DNA Whitepaper',
    community: 'Community Updates Mailing List',
    comText: 'Need to stay updated on all the node and protocol changes, network update details, community updates and events? Join our mailing list',
    mailPlace: 'Type your email address',
    comBtn: 'Stay Updated',
    comBtnJoin: 'Success',
    exchange: 'Metaverse DNA is the building block of Financial Technology 2.0 powered by unparalleled security, state-of-the-art digital assets, versatile digital identities, and a next-generation decentralized exchange.',
    contact: 'Contact Us',
    reserved: '© 2016-2020 Metaverse Foundation. All Rights Reserved.',
    emailGeneralTitle: 'General Inquiries',
    emailGeneral: "contact@mvsdna.com",
    emailMediaTitle: 'Media Inquiries',
    emailMedia: "press@mvsdna.com",
    dev: {
        start: 'Start Working with DNA',
        details: "If you’re a builder, you’ve come to the right place. Explore comprehensive guides and documentation to help you start working with DNA as quickly as possible, as well as support if you get stuck. Let's jump right in!",
        btn: 'Get Started',
        docs: 'DNA Docs',
        docDetails: 'General documentation covering APIs, integration guides, protocol designs and more.',
        github: 'Github',
        githubDetails: 'Meet our community of developers to discover, share, and build.',
        testnet: 'Testnet',
        testnetDetails: 'get free testnet DNA to be used for developing and testing applications.',
        whitepaper: 'Whitepaper',
        whitepaperDetails: 'A technical overview of Metaverse DNA and the original design for the modern decentralized finance infrastructure.'
    },
    what: {
        title: 'What is Metaverse DNA?',
        text1: 'As distributed ledger technology enters its second decade, there is an wide field of decentralized platforms designed to offer specific features. But all of these are separate, exclusive platforms with no inter-communication. The next generation of public blockchain will need to bring these features together seamlessly in one place if true adoption is ever to occur.',
        text2: 'Dualchain Network Architecture (DNA) is designed to do just that. A second chain, powered by DNA tokens, will operate on a delegated proof-of-stake consensus algorithm.',
        btn: 'Metaverse DNA Whitepaper',
        features: {
            title: 'Advanced Features',
            subtitle1: 'Governance',
            subtext1: 'DNA will operate on a three-tier node structure. Child Nodes delegate their \nstaking power to Regular Nodes, who confirm blocks and return their delegates’ \nportion of block rewards. Regular Nodes elect or replace Super Nodes, who vote \non proposal amendments and upgrades. Anyone can contribute to decentralized \ngovernance, regardless of their holdings or technical expertise.',
            subtitle2: 'Lightning Transactions',
            subtext2: 'DNA features prebuilt lightning channels between Super Nodes and Regular \nNodes.',
            subtext3: 'If the participants have an open channel to any of these nodes, they will enjoy \nlightning-fast transactions and minimal fees.',
            super: 'Super',
            regular: 'Regular',
            child: 'Child',
            nodes: 'Nodes'
        },
        token: {
            title: 'What is DNA Token?',
            text1: 'DNA is Metaverse DNA’s native currency, which a digital asset that can be sent over the network easily, securely, and instantly. It is also an essential part of the blockchain ecosystem and will be used in Metaverse-based applications.',
            text2: 'You can invest in DNA easily by visiting one of our officially recognized cryptocurrency exchange where it is ',
            text3: 'Want to know how to store your DNA once you have it? Get an ',
            text4: 'Want to track your DNA transfer records? Use our ',
            span2: 'traded.',
            span3: 'Metaverse DNA wallet.',
            span4: 'Metaverse DNA Explorer.'
        },
        version: 'Helix Version 1.0',
        versionText: 'We are proud to release the first version of the Metaverse DNA mainnet. This is the culmination of over years of hard work from the entire Metaverse team, developers, investors, advisors and most importantly, the entire Metaverse DNA community who have supported us on our journey so far.',
        tps: 'Transactions Per Second (TPS)',
        higher: 'Much Higher TPS than Market Competitors',
        time: 'Block Time',
        digital: 'Digital Identity',
        simple: 'Simple Account Setup and Easy-to-use Transfers on Metaverse DNA',
        price: 'Price Per Transaction',
        according: '*According to July 16th, 2020 Prices',
        read: 'Read our Whitepaper',
        map: 'DNA Roadmap'

    },
    connect: {
        tit1: 'Metaverse DNA Communities',
        text1: 'The Metaverse DNA community includes developers, technologists, users, HODLers, and enthusiasts all over the world. There are many ways to get involved in the DNA community: you can attend an event, join a meetup group, or contribute to a project.',
        tit2: 'Latest Blogs',
        tit3: 'Become a DNA Global Ambassador',
        text3: 'The total value of DNA tokens that will be rewarded in the DNA Ambassador Program is $1,000,000 USD. An ambassador who demonstrates exceptional quality and achievements will be given the honorable and official title, “DNA Global Ambassador.” The DNA Ambassador has the potential to receive an unlimited performance-based reward. The reward system is tiered into three levels with the corresponding reward amount and benefits.',
        objectives: 'Objectives',
        o1: 'Create and increase awareness of the Metaverse DNA project, share information about Metaverse DNA and its ecosystem',
        o2: 'Provide necessary support for potential cooperation opportunities with local businesses, organizations and communities',
        o3: 'Help build up local Metaverse DNA communities',
        system: 'Reward System',
        table: [
            { t1: 'Tier', t2: 'Title', t3: 'Maximum Reward (Monthly)' },
            { t1: '1', t2: 'Ambassador', t3: '1200 USD - Unlimited' },
            { t1: '2', t2: 'Navigator', t3: '800 USD' },
            { t1: '3', t2: 'Explorer', t3: '500 USD' }
        ],
        tit4: 'Start Your Application',
        text4: 'Complete the quick application below and if your profile matches the role, we will reach out to you to complete the recruiting process.',
        btn: 'Get Started',
        partners: 'Media Partners',
        exchanges: 'Exchanges',
        backers: 'Our Backers'
    },
    dbi: {
        banner: 'The DNA Blockchain Institute (DBI) is an inclusive blockchain organization whose purpose is to introduce new standards and drive innovation in the public blockchain industry. Our community is composed of outstanding developers, entrepreneurs, technology visionaries, and life-long learners. We welcome anybody interested in improving upon the current public blockchain standards to drive blockchain adoption.',
        total: 'Total Funding',
        learn: '150 Million USD in Crypto Assets',
        open: 'Open Technology Standards',
        unresolved: 'Unresolved Issues with Current Public Blockchains',
        list: [
            ' Lacking Performance',
            'High Cost of Usage',
            'Transaction Fee System Limitations',
            'Public Chains exist on "Separate Islands"'
        ],
        text: [
            'In order to solve the problems of the public chain, it is time to join together and build together for the greater good of the blockchain industry.',
            'With careful examination of the derivation and research basis but not limiting the development framework of the public chain, the underlying development teams, including the Metaverse team, BitShares team, and Substrate team will develop in accordance with Open Technology Standards (OTS)',
            'The development process is an undertaking of healthy competition among the various frameworks. Under the same open standards, the DNA Blockchain Institute advisors will evaluate all develop teams.'
        ],
        go: 'Go to OTS Whitepaper',
        sign: 'Sign Up Email for Opportunities and Updates',
        fund: [
            {
                tit: 'Funding and Grants',
                text: 'The DBI will offer 2 types of grants to organizations and projects, who can support the Metaverse DNA ecosystem and make outstanding contributions to Metaverse DNA protocol:'
            },
            {
                tit: 'Technical Grants:',
                text: 'Designed to foster development work around Metaverse DNA protocol as well as to facilitate its integration into different public blockchain developer communities. The grants can be used to introduce best-in-class standards to Metaverse DNA and implement Metaverse DNA Improvement Proposals.'
            },
            {
                tit: 'Ecosystem Grants:',
                text: 'Designed to incentivize developers to build applications and businesses based on our Best-in-class infrastructure. Initially, we will primarily focus on DeFi applications. However, we welcome the development of other decentralized applications as well should they add value to our ecosystem.'
            }
        ],
        proposal: 'Proposal Evaluation',
        ptxt: 'We will evaluate each proposal carefully and use a transparent vetting process in order to determine who will be eligible to receive financial support from the Institute.',
        the: 'The Proposal evaluation process will proceed as follows:',
        call: 'Call for Applicants',
        initial: 'Initial Proposal Review & Due Diligence',
        official: 'Official Grant Approval',
        start: 'Start Your Application',
        about: 'About Us',
        atxt: 'Created from the funding of Metaverse DNA, the DNA Blockchain Institute (DBI) will create industry reports and insights for the benefit of the entire industry, as well as overseeing the entire future development of DNA Chain\'s ecosystem',
        a1: 'Develop a deep understanding of each Blockchain protocol.',
        a2: 'Define standards based on strong academic requirements.',
        a3: 'Open ourselves to all public blockchains with a unique value proposition.',
        a4: 'Develop a high-degree of business acumen and facilitate interoperability between Blockchains for high-value business use cases.'
    }
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js